import React, { useState, useEffect } from "react";

import { createPortal } from "react-dom";
import "./logo.less";
import LogoImage from "@src/assets/icons/logo-windturbine.svg";
import DualisName from "@src/assets/icons/logo.svg";

const DynamicEffectOverlay = () => {
  return createPortal(
    <div className="wind-overlay">
      {[...Array(8)].map((_, i) => (
        <svg
          key={i}
          className={`wind-stream wind-stream-${i + 1}`}
          viewBox="0 0 200 60"
          preserveAspectRatio="none"
        >
          <defs>
            <linearGradient
              id={`fx-grad-${i}`}
              x1="0%"
              y1="0%"
              x2="100%"
              y2="0%"
            >
              <stop offset="0%" stopColor="rgba(0, 150, 255, 0)" />
              <stop offset="50%" stopColor="rgba(0, 150, 255, 0.6)" />
              <stop offset="100%" stopColor="rgba(0, 150, 255, 0)" />
            </linearGradient>
          </defs>
          <path
            d="M 0 30 Q 50 10 100 30 T 200 30"
            fill="none"
            stroke={`url(#fx-grad-${i})`}
            strokeWidth="3"
          />
        </svg>
      ))}
    </div>,
    document.body
  );
};

const Logo = () => {
  const [mode, setMode] = useState(0);
  const isActive = mode >= 3;

  useEffect(() => {
    if (isActive) {
      const timer = setTimeout(() => setMode(0), 10000);
      return () => clearTimeout(timer);
    }
  }, [isActive]);

  const handleInteraction = () => {
    setMode((prev) => (prev >= 3 ? 0 : prev + 1));
  };

  return (
    <div className="logo">
      {isActive && <DynamicEffectOverlay />}
      <LogoImage
        data-testid="logo-windturbine"
        className={`logo__wind-turbine ${
          isActive ? "logo__wind-turbine--spinning" : ""
        }`}
        onClick={handleInteraction}
        style={{ cursor: "pointer" }}
      />
      <DualisName className="logo__name" data-testid="logo" />
    </div>
  );
};

export default Logo;
